import React from 'react'
import { HeadProps } from 'gatsby'

import { formatOgpUrl } from '@atoms/MicrocmsImage'
import Seo from '@src/components/Seo'
import { convertPlainTitle, Parent } from '@models/Parent'
import { Locale } from '@models/Translation'
import { removeHtmlTags } from '@models/Util'

type HeadData = {
  parent: Parent
  englishParent: Parent
}
type HeadContext = {
  language: Locale
}
export const Head = ({
  data,
  pageContext,
  location,
}: HeadProps<HeadData, HeadContext>) => {
  const locale = pageContext.language
  const parent = locale === 'en' ? data.englishParent : data.parent

  if (locale === 'en' && parent === null) {
    return <meta httpEquiv="refresh" content={'1; url=/en'} />
  }

  const title = parent.projectName || convertPlainTitle(parent.title, locale)
  const imageUrl = formatOgpUrl(parent.image.url)

  return (
    <Seo
      pathName={location.pathname}
      title={title}
      description={removeHtmlTags(parent.contents)}
      imageUrl={imageUrl}
    />
  )
}
